// extracted by mini-css-extract-plugin
module.exports = {"box":"ErrorBoundaryClass_box__Fb1dP","errorboundary-btn":"ErrorBoundaryClass_errorboundary-btn__hDUtd"};